import type { StoreLocatorFilter } from "@locators/components/PrizeLocator/PrizeLocator.types";
import { CATEGORY } from "@locators/components/PrizeLocator/utils/getFiltersBaseOnFlotiqResponse";

import type { FlotiqStorePrizeLocator } from "@jti/fe-common";

const checkStoreBySelectedFilters = (store: FlotiqStorePrizeLocator, selectedFilters: StoreLocatorFilter) => {
  if (selectedFilters?.length === 0) {
    return true;
  }
  return selectedFilters.some(({ categoryKey }) => store[CATEGORY]?.find((filter) => filter.key === categoryKey));
};

export const getStoresFilteredBySelectedFilters = (
  stores: FlotiqStorePrizeLocator[],
  selectedFilters: StoreLocatorFilter
) => stores.filter((store) => checkStoreBySelectedFilters(store, selectedFilters));
